/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Lamp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z"
        opacity={0.2}
      />
      <Path
        d="M69.27517,40H186.72483a8,8,0,0,1,7.35316,4.84865l41.14286,96A8,8,0,0,1,227.86769,152H28.13231a8,8,0,0,1-7.35316-11.15135l41.14286-96A8,8,0,0,1,69.27517,40Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={128}
        y1={152}
        x2={128}
        y2={216}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={96}
        y1={216}
        x2={160}
        y2={216}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={200}
        y1={152}
        x2={200}
        y2={192}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Lamp;
